import { Close } from '@mui/icons-material'
import { Button, Grid, IconButton, Paper, Typography } from '@mui/material'
import _ from 'lodash'
import React, { memo, useEffect, useState } from 'react'
import QRCode from 'react-qr-code'
import { useStyle } from '../style'
import { data } from 'jquery'

const GenerateQR = ({data, close}) => {
    const classes = useStyle()
    const [printers, setPrinters] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState('barcode');
  console.log(data,printers,"printers");
  useEffect(() => {
    // Define the WebSocket settings
    window.JSPM.JSPrintManager.auto_reconnect = true;
    window.JSPM.JSPrintManager.start();
    window.JSPM.JSPrintManager.WS.onStatusChanged = () => {
      if (jspmWSStatus()) {
        // Get client installed printers
        window.JSPM.JSPrintManager.getPrinters().then(myPrinters => {
          // Append the 'Barcode' option to the list of printers
          const updatedPrinters = [...myPrinters, 'barcode'];
          // Update the printer list state
          setPrinters(updatedPrinters);
          console.log(updatedPrinters, "updatedPrinters");
        });
      }
    };
    
    const jspmWSStatus = () => {
      if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Open) {
        return true;
      } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Closed) {
        alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
        return false;
      } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Blocked) {
        alert('JSPM has blocked this website!');
        return false;
      }
    };
  
    // Cleanup function
    return () => {
      // Cleanup actions if needed
    };
  }, []);
  
  // useEffect(() => {
  //   // Define the WebSocket settings
  //   window.JSPM.JSPrintManager.auto_reconnect = true;
  //   window.JSPM.JSPrintManager.start();
  //   window.JSPM.JSPrintManager.WS.onStatusChanged = () => {
  //     if (jspmWSStatus()) {
  //       // Get client installed printers
  //       window.JSPM.JSPrintManager.getPrinters().then(myPrinters => {
  //         // Update the printer list state
          
  //         setPrinters(myPrinters);
  //         console.log(myPrinters,"myPrinters")
  //       });
  //     }
  //   };
  //   // Function to check JSPM WebSocket status
  //   const jspmWSStatus = () => {
  //     if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Open) {
  //       return true;
  //     } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Closed) {
  //       alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
  //       return false;
  //     } else if (window.JSPM.JSPrintManager.websocket_status === window.JSPM.WSStatus.Blocked) {
  //       alert('JSPM has blocked this website!');
  //       return false;
  //     }
  //   };

  //   // Cleanup function
  //   return () => {
  //     // Cleanup actions if needed
  //   };
  // }, []);
  const handlePrinterChange = event => {
    setSelectedPrinter(event.target.value);
  };
  console.log(selectedPrinter)
  const handleTestPrint = () => {
    if (selectedPrinter) {
      const content = generateXPML();
  
      console.log(content);
      // Convert the content string to a buffer
      const encoder = new TextEncoder();
      const buffer = encoder.encode(content);
      // Create a ClientPrintJob for test print
      const cpj = new window.JSPM.ClientPrintJob();
      // Set the selected printer for test print
      cpj.clientPrinter = new window.JSPM.InstalledPrinter(selectedPrinter);
      // Set the content to be printed (e.g., a test page)
      // const content = 'This is a test print from React app.';
     
   
      cpj.binaryPrinterCommands = new Uint8Array(buffer);
       
      cpj.sendToClient();
      
      
      console.log('Print job sent successfully!');
    }
  };
  const generateXPML = ( ) => {
    let xpmlMarkup = '';
    const Data = data.map(item => ({
      barcode: item.barcode,
      itemCode: item.sub_title,
      MRP: parseFloat(item.mrp.replace("Rs.", "").trim()),
      itemName: item.sub_title
    }));
  let j=0;
    for (let i = 0; i < Data.length; i++) {
      const dr = Data[i];
      // Check if it's the first item in the group of four
      if (i % 4 === 3) {
        xpmlMarkup += `
          TEXT 770,113,"3",180,1,1,"GIRLUSH"
          TEXT 790,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 788,61,"0",180,8,8,"Rs:"
          TEXT 750,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 790,32,"0",180,7,9,"${dr.barcode || ''}"
          QRCODE 670,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
        `;
      }
    
      // Check if it's the second item in the group of four
      if (i % 4 === 2) {
        xpmlMarkup += `
          TEXT 571,113,"3",180,1,1,"GIRLUSH"
          TEXT 591,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 589,61,"0",180,8,8,"Rs:"
          TEXT 551,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 591,32,"0",180,7,9,"${dr.barcode || ''}"
          QRCODE 471,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
        `;
      }
    
      // Check if it's the third item in the group of four
      if (i % 4 === 1) {
        xpmlMarkup += `
          TEXT 371,113,"3",180,1,1,"GIRLUSH"
          TEXT 391,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 389,61,"0",180,8,8,"Rs:"
          TEXT 351,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 391,32,"0",180,7,9,"${dr.barcode || ''}"
          QRCODE 271,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"
        `;
      }
    
      // Check if it's the last item in the group of four
      if (i % 4 === 0) {
        xpmlMarkup += `<xpml>
        <page quantity='0' pitch='15.0 mm'></xpml>SIZE 101.6 mm, 15 mm
        DIRECTION 0,0
        REFERENCE 0,0
        OFFSET 0 mm
        SET PEEL OFF
        SET CUTTER OFF
        SET PARTIAL_CUTTER OFF
        <xpml></page></xpml><xpml><page quantity='1' pitch='15.0 mm'></xpml>SET TEAR ON
        CLS`;

        xpmlMarkup += `
          TEXT 172,113,"3",180,1,1,"GIRLUSH"
          TEXT 192,83,"0",180,7,7,"${dr.itemCode && (dr.itemCode.length <= 12 ? dr.itemCode : dr.itemCode.substring(0, 12)) || ''}"
          TEXT 190,61,"0",180,8,8,"Rs:"
          TEXT 152,58,"0",180,8,8,"${Math.round(parseFloat(dr.MRP)) || 0}"
          TEXT 192,32,"0",180,7,9,"${dr.barcode || ''}"
          TEXT 48,102,"0",180,6,6,"${dr.purchaseCode || ''}"
          QRCODE 72,76,L,3,A,180,M2,S7,"${dr.barcode || ''}"  
        `; 
      }
j++;
if (j % 4 === 0) {
      xpmlMarkup += `
      PRINT 1,1
      <xpml></page></xpml><xpml><end/></xpml>
    `; 
    
}      
    }
    return xpmlMarkup;
  };
  console.log(data,"check")
  return (
   <Paper className='px-3 w-1/2 h-2/3'>
    <Grid className='my-2'>
     <Typography variant='h5' fontWeight={600} textAlign='center'>Product Name</Typography>
    </Grid>
    {/* Max height kuduthu... scrollable pannanum .. scrollbar vara kudathu */}
    <Grid container spacing={1} className={`h-3/4 overflow-auto ${classes.qrCodeGrid}`}>
        {_.map(data,(val)=>(
            <Grid item xs={4} className='p-2' >
            <Grid sx={{border:'1px solid', padding:1}}>
            <Typography textAlign='center'>{val.title}</Typography>
            <Grid className='flex items-center justify-between'>
                <Grid>
                    <Typography>{val.sub_title}</Typography>
                    <Typography>{val.mrp}</Typography>
                    <Typography>{val.barcode}</Typography>
                </Grid>
                <Grid  className='bg-green-400'>
                    <QRCode value={val.barcode} style={{height:50, width:50}}/>
                </Grid>
            </Grid>
            </Grid>
        </Grid>
        ))}
    </Grid>
<Grid className='flex justify-end pt-5'>
    <Button variant='outlined' sx={{marginInline:2}} onClick={()=>close(false)}>Cancel</Button>
    <select id="printerDropdown" value={selectedPrinter} onChange={handlePrinterChange} style={{border:"1px solid violet",marginInlineEnd:5}}>
        <option value="">Select Printer</option>
        {printers.map(printer => (
          <option key={printer} value={printer}>{printer}</option>
        ))}
      </select>

    <Button variant='contained' disabled={!selectedPrinter}  onClick={handleTestPrint}>Print</Button>
</Grid>
   </Paper>
  )
}

export default memo(GenerateQR)